<template>
<div id="contents">

  <div id="contact" class="page_contents">

    <div id="contact_contents">
      <div class="page_header">
        <h2>お問い合わせ</h2>
      </div><!-- .page_header -->

      <div id="contact_contents_main" v-if="input_flg">
        <p class="contact_read">TAP CASTに関するお問い合わせは、以下のフォームに記入の上、「ご記入内容確認へ」をクリックしてください。</p>

        <div id="contact_contents_box">
          <div class="clearfix">
            <div id="contact_contents_box_inner">

              <div class="contact_box">
                <h3>企業名</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.company" type="text" name="company" value="" class="required validate" id="company" placeholder="会社名を記入してください"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>連絡先</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.tel" type="number" name="tel" value="" class="validate number required" id="tel" placeholder=" 0335878111"  ></p>
                  <p class="read">※ハイフンはなしでご入力ください</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>メールアドレス</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.mail" type="mail" name="mail" value="" class="validate mail required" id="mail" placeholder=" abc@aaa.com"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>担当者名</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.staff" type="text" name="staff" value="" class="required validate" id="staff" placeholder="担当者名を記入してください"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>依頼内容</h3>
                <div class="contact_box_inner">
                  <ul id="js-inquiry" class="inquiry_list">
  										<li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio required validate" name="inquiry" value="TVラジオ出演依頼" checked>
                          <span class="radio-icon"></span>
                          TVラジオ出演依頼
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio " name="inquiry" value="雑誌取材依頼">
                          <span class="radio-icon"></span>
                          雑誌取材依頼
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="イベント出演依頼">
                          <span class="radio-icon"></span>
                          イベント出演依頼
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="ライブショー依頼">
                          <span class="radio-icon"></span>
                          ライブショー依頼
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="講演依頼">
                          <span class="radio-icon"></span>
                          講演依頼
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="その他">
                          <span class="radio-icon"></span>
                          その他
                        </label>
  										</li>
  									</ul>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>内容</h3>
                <div class="contact_box_inner">
                  <textarea v-model="contact_obj.contact_body" name="contact_body" rows="8" cols="80" class="required validate" placeholder="具体的な内容を記入してください"></textarea>
                  <p class="read contact_body_read">※必ずしも返信をお約束するものではありません。</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div id="form_btn_wrapper" class="form_btn_wrapper_check">
                <p class="form_btn"><a v-on:click="form_check" class="btn btn-white">ご記入内容の確認へ</a></p>
              </div><!-- #form_btn_wrapper -->

            </div><!-- #contact_contents_box_inner -->
          </div>

        </div><!-- #contact_contents_box -->
      </div><!-- #contact_contents_main -->

      <div id="contact_contents_main" v-else-if="!send_flg && !input_flg">
        <p class="contact_read">下記内容にて、送信致します。問題なければ「送信」をクリックしてください。</p>

        <div id="contact_contents_box">
          <form id="js-form" class="clearfix" action="" method="post">
            <div id="contact_contents_box_inner">

              <div class="contact_box" v-if="contact_obj.company">
                <h3>企業名</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.company }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.tel">
                <h3>連絡先</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.tel }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.mail">
                <h3>メールアドレス</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.mail }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.staff">
                <h3>担当者名</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.staff }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.inquiry">
                <h3>依頼内容</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.inquiry }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.contact_body">
                <h3>内容</h3>
                <div class="contact_box_inner">
                  <p v-html="contact_obj.contact_body.replace(/\n/g,'<br/>')"></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div id="form_btn_wrapper" class="form_btn_wrapper_check">
                <p class="form_btn"><a v-on:click="backinput" class="btn btn-white">修正</a></p>

                <p class="form_btn"><a v-on:click="mail_send" class="btn btn-white">送信</a></p>
              </div><!-- #form_btn_wrapper -->

            </div><!-- #contact_contents_box_inner -->
          </form>

        </div><!-- #contact_contents_box -->
      </div><!-- #contact_contents_main -->

      <div id="contact_contents_main" v-else-if="send_flg == true && input_flg == false">
        <p class="contact_read">お問い合わせをありがとうございます。送信を完了致しました。</p>
      </div><!-- #contact_contents_main -->


    </div><!-- #contact_contents -->
  </div><!-- #contact -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'tapcast_contact',
  data(){
    return {
      api_url: this.$parent.$parent.api_base_url+'/api/tapcast_contact/tapcast_send_mail.php',
      contact_obj: {
        company: '',
        tel: '',
        mail: '',
        staff: '',
        inquiry: '',
        contact_body: '',
        token: '',
        headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        }
      },
      input_flg: true,
      send_flg: false,
      referrer: this.$attrs.referrer,
      errors: []
    }
  },
  methods: {
    backinput: function(e){
      this.input_flg = true
      return false
    },
    form_check: function(e){
      $("span.error").remove();
      $(".contact_box_inner").removeClass("error");

      $(":text,[type='number'],[type='mail'],textarea").filter(".validate").each(function(){
          //必須項目のチェック
          $(this).filter(".required").each(function(){
            if($(this).val()==""){
              $(this).parent().prepend("<span class='error'>※必須項目です</span>")
            }
          })

          //数値のチェック
          $(this).filter(".number").each(function(){
            if(isNaN($(this).val())){
              $(this).parent().prepend("<span class='error'>数値のみ入力可能です</span>")
            }
          })

          //メールアドレスのチェック
          $(this).filter(".mail").each(function(){
            if($(this).val() && !$(this).val().match(/.+@.+\..+/g)){
              $(this).parent().prepend("<span class='error'>メールアドレスの形式が異なります</span>")
            }
          })
      });

      //ラジオボタンのチェック
      $(":radio").filter(".validate").each(function(){
        $(this).filter(".required").each(function(){
          if($("input[name="+$(this).attr("name")+"]:checked").length == 0){
            $(this).closest('.contact_box_inner').prepend("<span class='error'>※選択してください</span>")
          }
        })
      })

      //エラーの際の処理
      if($("span.error").length > 0){
        $('html,body').animate({ scrollTop: $("span.error:first").offset().top-40 }, 'slow');
        $("span.error").closest('.contact_box_inner').addClass("error");
      }else{
        this.input_flg = false
        $('html,body').animate({ scrollTop: $("#contact_contents").offset().top }, 'slow')
      }
      return false;
    },
    mail_send: function(){
      this.$axios
        .post(this.api_url,{
          company: this.contact_obj.company,
          staff: this.contact_obj.staff,
          tel: this.contact_obj.tel,
          mail: this.contact_obj.mail,
          inquiry: this.contact_obj.inquiry,
          contact_body: this.contact_obj.contact_body,
          token: 'vivia'
        },this.headers)
        .then(response => {
          console.log(response)
          if(response.data.response.header.status == 'success'){
            this.send_flg = true
            $('html,body').animate({ scrollTop: $("#contact_contents").offset().top }, 'slow')
          }else{
            alert('送信に失敗しました')
            this.send_flg = false
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
      return false
    }
  },
  mounted () {

    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    //リファラーによって、チェック
    if(this.$attrs.referrer){
      $('input[name=inquiry]').val([this.$attrs.referrer]);
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/tapcastContact.vue